import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAxios from "../hooks/useAxios";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const StatusUpdater = () => {
  const axiosInstance = useAxios();
  const { setStatus, setRole } = useContext(AuthContext);
  const location = useLocation();

  const fetchUserStatus = async () => {
    try {
      const response = await axiosInstance.get("/user/status");
      if (response.data.success) {
        setStatus(response.data.user.status); // Update status in AuthContext
        setRole(response.data.user.role);
        console.log(response.data)
      }
    } catch (error) {
      console.error("Error fetching user status:", error);
    }
  };

  // Trigger on every route change
  useEffect(() => {
    fetchUserStatus();
  }, [location]);

  return null;
};

export default StatusUpdater;
